

// 诚信车
const routerConfig = {
  baseUrl: '/TopicApp/2021/sinceritycar/',
  router: [
    {
      path: '/index',
      name: 'SincerityCar',
      component: resolve => require(['@/pages/SincerityCar/index'], resolve),
      meta: {
        title: '汽车之家诚信车'
      }
    },

  ]
}

export default routerConfig;


// WEBPACK FOOTER //
// ./src/router/routerConfig.js